"use client";

import React from "react";

import { iconColor } from "../colors";
import { createSVGIcon } from "../createSVGIcon";
import { iconCls } from "../tracking";

/**
 * @figma designed by Nick Howland (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=14271%3A161))
 * @trackcomponent
 * @lastsynced 2026-09-30T17:16:17.000Z
 * @optimized using svgo:^3.3.4
 */
export const BSRImageSearch = createSVGIcon(
  <path
    d="M9 21.25H2.75V15M15 21.25h6.25V15m0-4V4.889h-4.79a.31.31 0 0 1-.237-.108L14.467 2.75H9.533L7.777 4.78a.31.31 0 0 1-.237.109H2.75V11m13.236 1.993a3.993 3.993 0 1 1-7.986 0 3.993 3.993 0 0 1 7.986 0Z"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
  />,
  "BSRImageSearch",
  {
    className: iconCls(),
    color: iconColor.primary,
    fill: "none",
    viewBox: "0 0 24 24",
  } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
